import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { catchError, forkJoin, of } from 'rxjs';

export const initialDataResolver = () =>
{
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

  // Menu must not fail if optional Fuse mock endpoints error/cancel (e.g. after redirects)
    return forkJoin([
        navigationService.get(),
        messagesService.getAll().pipe(catchError(() => of([]))),
        quickChatService.getChats().pipe(catchError(() => of([]))),
        shortcutsService.getAll().pipe(catchError(() => of([]))),
    ]);
};
